import { createSelector } from '@reduxjs/toolkit';

import { selectDecoratedDeliveryOptions } from 'src/components/molecules/DeliveryBlock';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductDeliveryByEvent } from 'src/redux/selectors';
import { getMaxDeliveryDate, hasExactDeliveryDate, isLateDelivery } from './utils';

const selectSelectedDecoratedDeliveryOptions = (state: ReduxApplicationState) =>
  selectDecoratedDeliveryOptions(state);

export const selectCheapestDeliveryOptionPrice = createSelector(
  [selectSelectedDecoratedDeliveryOptions, selectProductDeliveryByEvent],
  (deliveryOptions, lastDeliveryByEvent): number | null =>
    deliveryOptions.reduce((cheapestDeliveryPrice, option) => {
      if (!lastDeliveryByEvent?.arriveByEvent) {
        return null;
      }

      const { lastDeliveryBy } = lastDeliveryByEvent;
      const {
        max,
        date,
        price: { amount },
      } = option;

      const numberAmount = Number(amount);
      const hasExactDeliveryDateOption = hasExactDeliveryDate(option);

      const isTimelyExactDeliveryDateOption =
        hasExactDeliveryDateOption && !isLateDelivery(date!, lastDeliveryBy);

      if (hasExactDeliveryDateOption && !isTimelyExactDeliveryDateOption) {
        return cheapestDeliveryPrice;
      }

      const isCheaperDeliveryOption =
        cheapestDeliveryPrice == null || numberAmount < cheapestDeliveryPrice;

      if (isTimelyExactDeliveryDateOption && isCheaperDeliveryOption) {
        return numberAmount;
      }

      const maxDeliveryDate = getMaxDeliveryDate(max!);

      if (isLateDelivery(maxDeliveryDate, lastDeliveryBy)) {
        return cheapestDeliveryPrice;
      }

      return isCheaperDeliveryOption ? numberAmount : cheapestDeliveryPrice;
    }, null as null | number),
);
